var _path, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCautious = function SvgCautious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 58,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__a",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.64.655h116.38v57.151H.64z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__b",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    stroke: "#C0EEC0",
    d: "m53.758 53.624 3.41-1.2L40.242 2.866l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__c",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    d: "M57.117 50.515 40.224.54l18.403-4.253L77.707.098l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__d",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    d: "M106.948 23.47 68.336 49.845l3.868 7.525h46.347l-3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__e",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 59.435,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    d: "m10.712 23.47 38.612 26.375-3.868 7.525H-.892l3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious_svg__f",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    d: "m65.194 52.22-3.429-1.142L77.866 1.245l18.484 8.67 10.862 13.722z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.829,
    cy: 59.442,
    r: 26.263,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m45.259 56.404-3.767-3.866 3.955-3.854M59.49 52.544l-16.5-.008"
  })));
};
export { SvgCautious as ReactComponent };
export default __webpack_public_path__ + "images/cautious.svg";